import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLeaveFromFriendsGroupMutation } from '@/api/queries/group';
import { defaultToastConfig } from '@/common/config/toast';
import { copyToClipboard } from '@/common/lib/copyToClipboard';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';

import copy from '/img/icons/dropDownList-more/copy.svg';
import delete_exit from '/img/icons/dropDownList-more/delete.svg';
import leave from '/img/icons/dropDownList-more/leave.svg';
import remove from '/img/icons/dropDownList-more/remove.svg';
import rename from '/img/icons/dropDownList-more/rename.svg';
import linkPng from '/img/icons/icon-link.png';
import linkWebp from '/img/icons/icon-link.webp';

interface prop {
  link: string;
  checkOwner: () => boolean;
  dropDownList: boolean;
  setDropDownList: (e: boolean) => void;
  setActiveRemoveFriendsMode: (e: boolean) => void;
  setNewGroupWindow: (e: boolean) => void;
}

const DropDownList: React.FC<prop> = ({
  link,
  checkOwner,
  dropDownList,
  setDropDownList,
  setActiveRemoveFriendsMode,
  setNewGroupWindow,
}) => {
  const [leaveGroup] = useLeaveFromFriendsGroupMutation();
  const { t } = useTranslation();

  return (
    <ul
      className="dropDownList"
      style={{ height: dropDownList ? '250px' : '0' }}
    >
      <li
        onClick={() => {
          copyToClipboard(link);
          showToast(
            t('Referral link copied.'),
            { img: linkPng, webp: linkWebp },
            defaultToastConfig,
          );
        }}
      >
        <img src={copy} alt="copy" />
        <span>{t('Copy link')}</span>
      </li>
      {checkOwner() && (
        <>
          <li onClick={() => setNewGroupWindow(true)}>
            <img src={rename} alt="rename" />
            <span>{t('Rename group')}</span>
          </li>
          <li
            onClick={() => {
              setActiveRemoveFriendsMode(true);
              setDropDownList(false);
            }}
          >
            <img src={remove} alt="remove" />
            <span>{t('Remove friends')}</span>
          </li>
        </>
      )}
      {checkOwner() ? (
        <li
          style={{ color: 'var(--text-Error, #FF5858)' }}
          onClick={() => leaveGroup()}
        >
          <img src={delete_exit} alt="delete" />
          <span>{t('Exit & Delete')}</span>
        </li>
      ) : (
        <li
          style={{ color: 'var(--text-Error, #FF5858)' }}
          onClick={() => leaveGroup()}
        >
          <img src={leave} alt="delete" />
          <span>{t('Leave group')}</span>
        </li>
      )}
    </ul>
  );
};

export default DropDownList;
